export enum ModuleName {
  videos = "Text-To-Video",
  agents = "Agents",
  avatars = "Avatars",
  home = "Home",
}
